/* AutoAssignSummaryRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

class AutoAssignSummaryRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("auto-assign-summary-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;

        this._titlePanel = document.createElement("h2");
        this._titlePanel.classList.add("summary-title");

        this._summaryPanel = document.createElement("div");
        this._summaryPanel.classList.add("summary");

        this._buttonBar = document.createElement("div");
        this._buttonBar.classList.add("summary-buttons");

        this._okButton = new ButtonControl({
            label: "OK",
            darkTheme: true,
            type: "additive",
        });

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._okButton.on("UserClick", (this._onOkClick = this._onOkClick.bind(this)));
    }

    _unregisterListeners() {
        this._okButton.removeAllListeners("UserClick");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /* jshint ignore:start */
    async shutdown() {
        this._unregisterListeners();
        await this._okButton.shutdown();
        this._summaryPanel = undefined;
        this._rootElem = undefined;
    }
    /* jshint ignore:end */

    render() {
        return new Promise((resolve) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titlePanel);
                this._rootElem.appendChild(this._summaryPanel);
                this._rootElem.appendChild(this._buttonBar);
                this._buttonBar.appendChild(this._okButton.renderer.rootElement);
                this._displaySummary();
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onOkClick() {
        this._model.sendOk();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _displaySummary() {
        this._titlePanel.innerHTML = "Site auto-assignment completed";

        const {
            targetSitesWithRegex,
            devicesProcessed,
            devicesAssignedToNew,
            devicesAlreadyAssigned,
        } = this._model._autoAssignResults.summary;

        const sitesLabel = document.createElement("span");
        sitesLabel.innerText = `Sites with auto-assignment enabled: ${targetSitesWithRegex || 0}`;
        this._summaryPanel.appendChild(sitesLabel);

        const devicesProcessedLabel = document.createElement("span");
        devicesProcessedLabel.innerText = `Devices evaluated: ${devicesProcessed || 0}`;
        this._summaryPanel.appendChild(devicesProcessedLabel);

        const brEl = document.createElement("br");
        this._summaryPanel.appendChild(brEl);

        const devicesAssignedLabel = document.createElement("span");
        devicesAssignedLabel.innerText = `New device assignments: ${devicesAssignedToNew || 0}`;
        this._summaryPanel.appendChild(devicesAssignedLabel);

        const devicesExistingLabel = document.createElement("span");
        devicesExistingLabel.innerText = `Unchanged device assignments: ${
            devicesAlreadyAssigned || 0
        }`;
        this._summaryPanel.appendChild(devicesExistingLabel);
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /*******************************************/
}

module.exports = AutoAssignSummaryRenderer;
